var render = function render(){var _vm=this,_c=_vm._self._c;return _c('balance',{attrs:{"title":_vm.title,"cols":_vm.cols,"url":_vm.url,"showAccountFilters":false,"getAccountLedgerQuery":_vm.getAccountLedgerQuery}})
}
var staticRenderFns = []

export { render, staticRenderFns }